<template>
    <header class="menuBar justify-content-center align-items-center">
        <div :class="['menu-container inter-300',{menu_container_open:menuIsOpen}]">
            <button class="btn__menu cursor-pointer " @click="toggleMenu">
                <svg :class="[{btn__menu_open:menuIsOpen}]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M64 320C64 461.4 178.6 576 320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320zM305 441C295.6 450.4 280.4 450.4 271.1 441C261.8 431.6 261.7 416.4 271.1 407.1L358.1 320.1L271.1 233.1C261.7 223.7 261.7 208.5 271.1 199.2C280.5 189.9 295.7 189.8 305 199.2L409 303C418.4 312.4 418.4 327.6 409 336.9L305 441z"/></svg>
            </button>
            <a href="#home" class="menu-title p-1 brand-text"  @click="toggleMenu">rolandogomez.dev</a>
            <a href="#home"><img src="../assets/icons/icon.jpg" alt="Logo" class="brand-logo"></a>
            <ul class="menu-list">
                <a href="#projects" class="menu-item cursor-pointer "  @click="toggleMenu">proyectos</a>
                <a href="#skills" class="menu-item cursor-pointer "  @click="toggleMenu">habilidades / herramientas</a>
                <a href="#contact" class="menu-item cursor-pointer "  @click="toggleMenu">contacto</a>
            </ul>
            <a href="/rolandoGomez.pdf" target="_blank" class="btn cursor-pointer " @click="toggleMenu">
                Descargar CV <img src="../assets/icons/download.svg" ></a>
        </div>
    </header>
</template>

<script setup>
import { ref } from 'vue';

const menuIsOpen = ref(false);
const toggleMenu = () => {
    menuIsOpen.value = !menuIsOpen.value;
};
</script>

<style lang="css" scoped>
.menu-title {
    display: block;
    width: 100%;
    text-align: center;
    font-weight: 600;
    font-size: 1.5em;
}

.menuBar {
    width: 100vw;
    display: flex;
    position: fixed;
    z-index: 100;
    display: block;
    justify-items: center;
    overflow: hidden;
    background-color: #EBEBE8;

}
.btn__menu{
    color: var(--secondary-bg-color);
    font-size: 0.8em;
    width: 40px;
    height: 40px;
    font-weight: 600;
    font-size: 1em;
    border-radius: 50%;
    border: none;
    background-color: transparent;
    position: absolute;
    top: 19px;
}
.btn__menu_open{
    transform: rotate(90deg);
    fill: #065c8a;
}

.btn__menu svg{
    width: 100%;
    height: 100%;
    fill: #000000;
    transition: all 400ms ease-in-out;
}
.menu-container {
    width: 90%;
    display: flex;
    height: 100%;
    gap: 6px;
    transition: all 300ms ease-in-out;
    justify-content: space-between;
    padding: 0.5em;
    flex-direction: column;
    height: 70px;
    overflow: hidden;
}
.menu_container_open{
    height: 200px;
}
.menu-list {
    background-color: #EBEBE8;
    color: rgb(0, 0, 0);
    list-style: none;
    display: flex;
    border-radius: 40rem;
    gap: 6px;
    text-transform: capitalize;
    font-size: 0.8em;
    padding: 0.3em;
    flex-direction: column;
}

.menu-item {
    border-radius: 40rem;
    width: max-content;
}

.btn {
    border: 2px solid;
    border-radius: 0.9rem;
    background-color: var(--secondary-bg-color);
    border: 1px solid;
    text-decoration: none;
    color: rgb(255, 255, 255);
    font-size: 0.8em;
    width: 1em;
    text-wrap: nowrap;
    text-align: right;
    flex: 1;
    padding: 0.3em 1em;
    width: max-content;
}

.brand-text {
    animation: hideText linear forwards;
    animation-timeline: scroll();
    animation-range: 0 12em;
   
    transition: all 1000ms cubic-bezier(0.075, 0.82, 0.165, 1);
}

.brand-logo {
    position: absolute;
    height: 56px;
    border-radius: 50%;
    padding: 0px;
    border: 1px solid;
    left: 02%;
    transform: translateY(-50%);
    opacity: 1;
    animation: showLogo linear forwards;
    animation-timeline: scroll();
    animation-range: 0 120px;
    box-shadow: 0 0 4px rgb(185, 185, 185);
    transition: all 1000ms cubic-bezier(0.075, 0.82, 0.165, 1);
    display: none;
}



@media (min-width: 768px) {
    
    .btn__menu{
        display: none;
    }
    .menu-title {
        display: block;
        border-radius: 40rem;
        border: 1px solid;
        font-weight: normal;
        font-size: 0.9em;
        background-color: #FEFEFD;
    }
    .menuBar {
        display: flex;
        top: 1.5em;
        height: 76px;  
        font-size: 1.1em;
        background-color: transparent;
        overflow: visible;
      }
      .menu-container{
        width: max-content;
        gap: 17px;
        background-color: #d1d1d13e;
        backdrop-filter: blur(6px);
        -webkit-backdrop-filter: blur(6px);
        padding: 10px;
        border-radius: 40rem;
        flex-direction: row;
        height: max-content;
        overflow: visible;
        box-shadow: 0 0 4px rgb(185, 185, 185);
      }
      .menu-list{
        border: 1px solid;
        gap: 26px;
        padding: 15px;
        display: flex;
        flex-direction: row;
      }
      .brand-logo{
        display: block;
      }
      .btn{
        width: max-content;
        padding: 15px;
        display: block;
        border-radius: 40rem;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 130px;
      }
      @keyframes hideText {
        from {
                opacity: 1;
                transform: scale(1);
                width: 169px;
            }

            to {
                opacity: 0;
                transform: scale(.2);
                width: 56px;
            }
        }

        @keyframes showLogo {
            from {
                opacity: 0;
                transform: scale(0);
                width: 0px;
            }

            to {
                opacity: 1;
                transform: scale(1);
                width: 56px;
            }
        }
}
</style>